import Image from "next/image"
import { Stack } from "@octopus-energy/coral/atoms"
import { FormikTextField } from "@octopus-energy/coral/formik"
import { useTranslations } from "next-intl"
import { MeterPointAccordion } from "@/features/meter-points/components/MeterPointAccordion"
import { type EnergyType } from "@/features/subscription"
import { useMeterPowerAnalysisWizard } from "../../wizard"

type MeterPointIdFormProps = {
    energyType: EnergyType
}

export function MeterPointIdForm({ energyType }: MeterPointIdFormProps) {
    const t = useTranslations("MeterPointIdForm")
    const { formValues } = useMeterPowerAnalysisWizard()

    return (
        <Stack
            flexDirection="column"
            gap="lg"
        >
            <Stack justifyContent="center">
                <Image
                    alt={t("common.imageAlt")}
                    src="/assets/images/illustrations/opti-compteur.svg"
                    width="382"
                    height="135"
                />
            </Stack>
            <Stack
                flexDirection="column"
                gap="xs"
            >
                <FormikTextField
                    name={"meterPointId"}
                    label={t(`${energyType}.input.label`)}
                    inputProps={{ inputMode: "numeric" }}
                    disabled={formValues.isFromDashboard}
                />
            </Stack>

            {!formValues.isFromDashboard && <MeterPointAccordion energyType={energyType} />}
        </Stack>
    )
}

MeterPointIdForm.messages = ["MeterPointIdForm", ...MeterPointAccordion.messages] as const
